<template>
	<ul class="file-overview-list">
		<slot />
	</ul>
</template>

<style lang="scss">
.file-overview-list {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
	grid-auto-rows: 1fr;
	padding: 0;
	justify-content: center;
	gap: 20px;

	@media screen and (max-width: 1200px) {
		grid-template-columns: 1fr 1fr 1fr 1fr;
	}

	@media screen and (max-width: 1000px) {
		grid-template-columns: 1fr 1fr 1fr;
	}

	@media screen and (max-width: 900px) {
		grid-template-columns: 1fr 1fr;
	}

	@media screen and (max-width: 400px) {
		grid-template-columns: 1fr;
	}
}
</style>
